import React from "react";
import { Card, Col } from "react-bootstrap";
import "./index.css";
import { TPainArea } from "../../routes/dashboard/components/ModalPainAreaRequest";
import { TProgramCategory } from "../../routes/program-library/Components/CategoryList";
import { BabyIcon, BalanceFallIcon, BoneIcon, FirstAidIcon, JobIcon, PersonRunIcon, SportIcon } from "../icons";

export const ComponentsIcons = {
  PersonRunIcon,
  JobIcon,
  BalanceFallIcon,
  BoneIcon,
  BabyIcon,
  SportIcon,
  FirstAidIcon,
};

interface TPainAreaWithType extends TPainArea {
  format_type?: string;
  img_component_name?: string;
}

type Props = {
  index: number;
  handleClick: Function;
  element: TPainAreaWithType | TProgramCategory;
  selected?: TPainArea;
  disable?: boolean;
};

export default function PainAreaCard(props: Props) {
  const { index, handleClick, element } = props;
  return (
    <Col key={index} className="justify-content-center">
      <Card
        className="pain-area-card"
        role="button"
        tabIndex={props.disable ? -1 : 0}
        onClick={() => {
          if (!props.disable) handleClick(element?.id, element?.survey_type);
        }}
        onKeyDown={e => {
          if (!props.disable && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            handleClick(element?.id, element?.survey_type);
          }
        }}
        style={props.selected && props.selected.id === element.id ? { outline: "2px solid #52CC7A" } : {}}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={
              element?.format_type === "category" ? { width: "50%", height: "auto", margin: "0 auto" } : {}
            }
          >
            {element?.img_url && (
              <img src={element?.img_url} alt={element?.title ?? ""} style={{ maxWidth: "100%", height: "auto" }} />
            )}
            {element?.img_component_name &&
              React.createElement(ComponentsIcons[element.img_component_name], { className: "pain-area-card-icon", "aria-hidden": true })}
          </div>
        </div>
        <Card.Body
          className="pain-area-card-body-text"
          style={{
            padding: "0.2em 0 0.9em 0",
            textAlign: "center",
            fontWeight: "800",
            fontSize: "15px",
            maxWidth: "200px",
          }}
        >
          {element?.title}
        </Card.Body>
      </Card>
    </Col>
  );
}
